const AppLogoRounded = () => {
    return (
        <svg width="100px" height="100px" viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>Group 3</title>
            <defs>
                <linearGradient x1="14.5829429%" y1="14.574848%" x2="85.3911513%" y2="85.3830563%" id="linearGradient-1">
                    <stop stopColor="#96EAF1" offset="0%"></stop>
                    <stop stopColor="#98E3F0" offset="12.32%"></stop>
                    <stop stopColor="#9FD1EC" offset="29.66%"></stop>
                    <stop stopColor="#A9B3E5" offset="49.99%"></stop>
                    <stop stopColor="#B889DD" offset="72.58%"></stop>
                    <stop stopColor="#CA54D2" offset="96.77%"></stop>
                    <stop stopColor="#CD4CD0" offset="100%"></stop>
                    <stop stopColor="#CF50D1" offset="100%"></stop>
                    <stop stopColor="#D55DD3" offset="100%"></stop>
                    <stop stopColor="#DF73D6" offset="100%"></stop>
                    <stop stopColor="#EE91DB" offset="100%"></stop>
                    <stop stopColor="#FFB6E1" offset="100%"></stop>
                </linearGradient>
            </defs>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="PPDesktopLanding" transform="translate(-788, -56)" fillRule="nonzero">
                    <g id="Group-6" transform="translate(698, 56)">
                        <g id="Group-3" transform="translate(90, 0)">
                            <circle id="Oval-Copy" fill="url(#linearGradient-1)" cx="50" cy="50" r="50"></circle>
                            <g id="Group-31" transform="translate(33, 30)" fill="#FFFFFF">
                                <path d="M3.51297405,40 C1.59680639,40 0,38.4031936 0,36.4870259 L0,24.2714571 C0,17.7245509 5.26946108,12.4550898 11.8163673,12.4550898 L21.9560878,12.4550898 C23.8722555,12.4550898 25.4690619,14.0518962 25.4690619,15.9680639 C25.4690619,17.8842315 23.8722555,19.4810379 21.9560878,19.4810379 L11.8163673,19.4810379 C9.18163673,19.4810379 7.0259481,21.6367265 7.0259481,24.2714571 L7.0259481,36.4870259 C7.10578842,38.4031936 5.50898204,40 3.51297405,40 Z" id="Path"></path>
                                <path d="M23.3932136,31.7764471 L19.8802395,31.7764471 C17.9640719,31.7764471 16.3672655,30.1796407 16.3672655,28.2634731 C16.3672655,26.3473054 17.9640719,24.750499 19.8802395,24.750499 L23.3932136,24.750499 C28.6626747,24.750499 32.8942116,20.758483 32.8942116,15.8882236 C32.8942116,11.0179641 28.5828343,7.0259481 23.3932136,7.0259481 L8.30339321,7.0259481 C6.38722555,7.0259481 4.79041916,5.42914172 4.79041916,3.51297405 C4.79041916,1.59680639 6.38722555,0 8.30339321,0 L23.3932136,0 C32.5748503,0 40,7.18562874 40,15.9680639 C40,24.750499 32.49501,31.7764471 23.3932136,31.7764471 Z" id="Path"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default AppLogoRounded;
